import React, { Component } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../ExternalCSS/OurPartner.css"

const OurPartner = () => {

  const settings = {
    dots: false,           // no dots
    arrows: false,         // no prev/next arrows
    infinite: true,
    speed: 5000,           // total time to scroll one “page”
    autoplay: true,
    autoplaySpeed: 0,      // gap between plays; 0→continuous
    cssEase: "linear",     // smooth, constant speed
    slidesToShow: 5,       // adjust how many logos you see at once
    slidesToScroll: 1,
    pauseOnHover: false,
    ltl: true              // right-to-left direction
  };


  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let data = sectiondata.partner


  return (
    <div className="client-area pd-top-92 pd-bottom-100">
      <div className="container">
        <div className="section-title text-center">
          <h2 className="title">{data.title}</h2>
        </div>
        {/* <div className="client-slider"> */}
          <Slider {...settings}>
            {data.items.map((item, i) =>
              <div key={i} className="partner-slide">
                <div className="thumb">
                  <img src={publicUrl + item.image} alt="client"    className="partner-logo" />
                </div>
              </div>
            )}
          </Slider>
        {/* </div> */}
      </div>
    </div>
  )
}

export default OurPartner